import type { RateKey } from '../types';

export const E_1: RateKey = 'E-1';
export const EV2_A: RateKey = 'EV2-A';
export const E_TOU_C: RateKey = 'E-TOU-C';
export const E_TOU_D: RateKey = 'E-TOU-D';
export const EV_B: RateKey = 'EV-B';
